// Groups the AHA catalog into the course families people recognize, for the class's "AHA course" picker.

export const COURSE_FAMILIES = [
  "Heartsaver",
  "BLS",
  "ACLS",
  "PALS",
  "PEARS",
  "ASLS",
  "Instructor courses",
  "HeartCode",
  "Other",
];

/** The family a catalog product key belongs to (instructor and HeartCode courses are their own families). */
export function courseFamily(key = "") {
  const k = String(key).toUpperCase();
  if (k.startsWith("HEARTCODE_")) return "HeartCode";
  if (k.includes("INSTRUCTOR")) return "Instructor courses";
  if (k.startsWith("HS_") || k.startsWith("HEARTSAVER")) return "Heartsaver";
  if (k.startsWith("ASLS_")) return "ASLS";
  if (k.startsWith("BLS_")) return "BLS";
  if (k.startsWith("ACLS_")) return "ACLS";
  if (k.startsWith("PALS_")) return "PALS";
  if (k.startsWith("PEARS_")) return "PEARS";
  return "Other";
}

/** Whether a catalog product can be sent in the connected environment. */
export const isCourseAvailable = (product) => !!(product?.environment?.verified && product?.environment?.active);

export const courseLabel = (product) =>
  product ? `${product.name}${product.edition ? ` (${product.edition})` : ""}` : "";

/**
 * [{ family, products }] in family order; within a family, available courses first, then newest edition first,
 * then by name.
 */
export function groupCourses(products = []) {
  const groups = new Map(COURSE_FAMILIES.map((f) => [f, []]));
  products.forEach((p) => groups.get(courseFamily(p.key)).push(p));
  return COURSE_FAMILIES.map((family) => ({
    family,
    products: groups.get(family).slice().sort((a, b) =>
      Number(isCourseAvailable(b)) - Number(isCourseAvailable(a))
      || String(b.edition || "").localeCompare(String(a.edition || ""))
      || String(a.name).localeCompare(String(b.name))),
  })).filter((g) => g.products.length > 0);
}
